import React, { useState } from 'react'
import { TripListItem, RouteListItem, GearListItem, SubscriptionListItem } from 'common/ListItems'
import { Route, Trip, Gear, Subscription } from 'data/records'
import { CTA } from 'common/styleguide/CTA'
import { CircleSpinner } from 'common/spinners/CircleSpinner'
import cardStyles from 'common/SearchableCard/SearchableCard.scss'
import { DEFAULT_PER_PAGE } from 'lib/loadAllPages'
import { Msg, commonActions, commonMessages } from 'lib/localization'
import { routeApi } from 'data/resources/routes'
import { tripApi } from 'data/resources/trips'

export class FeedActivity extends React.PureComponent {
  render () {
    const {
      feed: { results, extras, total_count: totalCount },
      currentUser,
      loadMore,
      loadingMore,
      offset
    } = this.props
    const zipped = results && extras
      ? pick(results, extras)
      : []

    return (
      <div>
        {zipped.map(z => z[1] && <ActivityItem key={z[1].id} r={z[0]} e={z[1]} currentUser={currentUser} />)}
        {totalCount > results.length && totalCount > DEFAULT_PER_PAGE &&
          <div className={cardStyles.resultsFooter}>
            <CTA inline secondary margins={false} disabled={loadingMore} onClick={() => !loadingMore && loadMore()}>
              {loadingMore && <CircleSpinner size={14} />} <Msg m={commonActions.loadMore} />
            </CTA>
          </div>}
        {!loadingMore &&
          totalCount > DEFAULT_PER_PAGE &&
          (offset + DEFAULT_PER_PAGE) >= totalCount &&
          <div className={cardStyles.resultsFooter}>
            <span className={cardStyles.footerText}><Msg m={commonMessages.noMoreItems} /></span>
          </div>}
      </div>
    )
  }
}

const pick = (results, extras) => (results.map(r => [r, extras.filter(e => e && e.id === r.associatedObjectId)[0]]))

const ActivityItem = ({ r, e, currentUser }) => {
  const friend = {
    name: r.content.user_name,
    id: r.content.user_id,
    highlightedPhotoId: r.content.highlighted_photo_id
  }

  if (e instanceof Route) {
    return <LocalRouteListItem e={e} friend={friend} />
  } else if (e instanceof Trip) {
    return <LocalTripListItem e={e} friend={friend} />
  } else if (e instanceof Gear) {
    return <GearListItem isFeedEntry gear={e} friend={friend} />
  } else if (e instanceof Subscription) {
    return <SubscriptionListItem isFeedEntry subscription={e} currentUser={currentUser} friend={friend} />
  }
}

// these are this way because the feed isn't in redux, so we can't dispatch v3
// actions from the RichListItem and expect the changes to show up in v3 selectors
// definitely a HACK. the fix is to bring the feed into redux, potentially by adding
// a FeedItem resource
const LocalRouteListItem = ({ e, ...rest }) => {
  const [route, setRoute] = useState(e)
  const [posting, setPosting] = useState(false)

  const like = () => {
    if (posting) { return }
    setPosting(true)
    routeApi.like(route.id)
      .then(({ route }) => setRoute(route))
      .finally(() => setPosting(false))
  }
  const unlike = () => {
    if (posting) { return }
    setPosting(true)
    routeApi.unlike(route.id)
      .then(({ route }) => setRoute(route))
      .finally(() => setPosting(false))
  }
  return <RouteListItem isFeedEntry route={route} likable like={like} unlike={unlike} {...rest} />
}

const LocalTripListItem = ({ e, ...rest }) => {
  const [trip, setTrip] = useState(e)
  const [posting, setPosting] = useState(false)

  const like = () => {
    if (posting) { return }
    setPosting(true)
    tripApi.like(trip.id)
      .then(({ trip }) => setTrip(trip))
      .finally(() => setPosting(false))
  }
  const unlike = () => {
    if (posting) { return }
    setPosting(true)
    tripApi.unlike(trip.id)
      .then(({ trip }) => setTrip(trip))
      .finally(() => setPosting(false))
  }
  return <TripListItem isFeedEntry trip={trip} likable like={like} unlike={unlike} {...rest} />
}
